import { Button, Modal, Steps } from 'antd'
import React, { useEffect, useState } from 'react'
import './ImportDataModal.scss'
import ImportDataStep2 from './Step2'
import useToast from '../../../../hook/useToast';
import ImportDataPreviewStep from './PreviewStep'
import { IDataError, ResponseSuccessDataError } from '../../../../api/customer/customerApi'
import ImportDataStep1V2 from './Step1_V2'
import ImportDataStep4V2 from './Step4_V2'
import useLoading from '../../../../hook/useLoading'
import { DataTypeError } from '../ColumnsDataError'
import { useSelector } from 'react-redux';
import { selectLoading } from '../../../../store/slices/loadingSlice';
import { formatDateToDMY, handleDateChangeDayJs } from '../../../../until';

interface Props {
  show: boolean
  linkExamplPre: string
  fileData: any
  type: string

  modalClose?: () => void
  paramMapChange?: () => void,
  gListCarColor?: () => void
  handleUpload: (type: string) => Promise<ResponseSuccessDataError>
  setFileData: (file: any) => void
  handleFile: (file: any) => void
}
export const defaultResource = {
  isSuccess: false,
  message: "",
  newlyCreatedRecords: 0 as number | undefined,
  totalRecords: 0 as number | undefined,
  unimportedRecords: 0 as number | undefined
}
const ImportDataColorCar: React.FC<Props> = ({
  show, linkExamplPre, fileData, type,
  modalClose, paramMapChange, gListCarColor, handleUpload, setFileData, handleFile
}) => {
  const pushToast = useToast();
  const pushLoading = useLoading()

  const isLoading = useSelector(selectLoading)

  const [currentStep, setCurrentStep] = useState(0)

  const [dataError, setDataError] = useState<DataTypeError[]>([])

  const [resource, setResource] = useState(defaultResource)

  const filesChange = async (e: any) => {
    if (e?.length) {
      setFileData(e[0])
      handleFile(e[0])
    }
    else
      setFileData(undefined)
  }

  const handleUploadResult = async () => {
    pushLoading(true)
    const result = await handleUpload(type)
    if (result.status) {
      setDataError(convertDataError(result.dataError))
      setResource({ isSuccess: true, message: result?.message ?? "", newlyCreatedRecords: result?.newlyCreatedRecords, totalRecords: result?.totalRecords, unimportedRecords: result?.unimportedRecords })
      setCurrentStep(3)
    } else {
      setDataError(convertDataError(result.dataError))

      setResource({ isSuccess: true, message: result?.message ?? "", newlyCreatedRecords: result?.newlyCreatedRecords, totalRecords: result?.totalRecords, unimportedRecords: result?.unimportedRecords })
      setCurrentStep(3)
    }
    pushLoading(false)
  }

  const convertDataError = (data: IDataError[]) => {
    let stt = 1
    const convertData = (data as any[])?.map((item) => {
      const row = item.row ?? item
      return {
        stt: stt++,
        titleCategoryCar: row?.titleCategoryCar,
        clCar: row?.titleTypeVehicle,
        codeCar: row?.code,
        nameCar: row?.titleCar,
        brand: row?.titleCategoryCar,
        typeCar: row?.titleCarLines,
        titleVehicleModel: row?.titleVehicleModel,
        titleVehicleGroup: row?.titleVehicleGroup,
        titleSegmentsVehicle: row?.titleSegmentsVehicle,
        codeB7: row?.codeB7,
        codeCustomer: row?.codeCustomer,
        date: formatDateToDMY(row?.dateReception),
        status: row?.typeSupport,
        note: row?.note,
        staff: row?.adminName,
        source: row?.supportChanel,
        system: row?.sourceCustomer,
        type: type
      }
    })
    return convertData
  }

  const handleUploadSuccess = () => {
    if (modalClose) {
      modalClose()
      gListCarColor?.()
    }
  }
  useEffect(() => {
    if (show) {
      setResource({ isSuccess: false, message: "", newlyCreatedRecords: 0, totalRecords: 0, unimportedRecords: 0 })
      setFileData({})
    }
  }, [show])
  return (
    <>
      <Modal
        open={show}
        title='Chọn hệ thống và nhập dữ liệu'
        className='rs-modal w-824 import-data-modal'
        maskClosable={false}
        keyboard={false}
        centered
        footer={() => (
          <>
            {
              currentStep === 0 && (
                <>
                  <Button
                    className="rs-button"
                    onClick={modalClose}
                  >Hủy</Button>
                  <Button
                    type="primary"
                    className="rs-button"
                    disabled={isLoading}
                    onClick={() => {
                      if (!fileData?.lastModified) {
                        pushToast('Vui lòng chọn file', "warning")
                      } else {
                        handleUploadResult()
                      }
                    }}
                  >Tiếp theo</Button>
                </>
              )
            }
            {
              (currentStep === 1) && (
                <>

                  <Button
                    className="rs-button"
                    onClick={() => {
                      setCurrentStep(0)
                    }}
                  >Quay lại</Button>
                  <Button
                    type="primary"
                    className="rs-button"
                    onClick={() => {
                      setCurrentStep(2)
                    }}
                  >Tiếp theo</Button>
                </>
              )
            }
            {
              (currentStep === 2) && (
                <>
                  <Button
                    className="rs-button"
                    onClick={() => {
                      // setCurrentStep(currentStep - 1)
                      setCurrentStep((current) => current - 1)
                    }}
                  >Quay lại</Button>
                  <Button
                    type="primary"
                    className="rs-button"

                  >Tiếp theo</Button>
                </>
              )
            }
            {
              currentStep === 3 && (
                <>
                  <Button
                    className="rs-button"
                    onClick={() => {
                      setCurrentStep(0)
                      setFileData({})
                      if (paramMapChange) {
                        paramMapChange()
                      }
                    }}
                  >Import thêm</Button>
                  <Button
                    type="primary"
                    className="rs-button"
                    onClick={() => {
                      handleUploadSuccess()
                      // if (paramMapChange) {
                      //   paramMapChange()
                      // }
                    }}
                  >Đóng</Button>
                </>
              )
            }
          </>
        )}
        onCancel={handleUploadSuccess}
        afterClose={() => setCurrentStep(0)}
      >
        <Steps
          current={currentStep}
          type="navigation"
          items={[
            {
              title: 'Tải file excel',
            },
            // {
            //   title: 'Kiểm tra trùng lặp',
            // },
            // {
            //   title: 'Thiết lập dữ liệu',
            // },
            // {
            //   title: 'Xem trước dữ liệu',
            // },
            {
              title: 'Kết quả',
            },
          ]}
          className='rs-steps'
        />

        <div className="import-data-modal-content">
          {
            currentStep === 0 &&
            <ImportDataStep1V2
              fileData={fileData}
              linkExamplPre={linkExamplPre}

              listFilesChange={(e) => filesChange(e)}
            />
          }
          {
            currentStep === 1 && <ImportDataStep2 />
          }
          {/* {
            currentStep === 1 && <ImportDataStep3
              source={source}
              colChange={(data) => colChange(data)}
              setShowParamModal={(data) => {
                setSourceId(data.source)
                setShowParamModal(true)
              }}
              fileData={fileData}
              columns={columns}
            />
          } */}
          {
            currentStep === 2 && <ImportDataPreviewStep fileData={fileData} />
          }
          {
            currentStep === 3 &&
            <ImportDataStep4V2
              type={type}
              dataError={dataError}
              resource={resource}
              fileData={fileData}
            />
          }
        </div>
      </Modal>

      {/* <CreateSystemParamModal
        show={showParamModal}
        source={source}
        sourceId={sourceId}
        hideStatus={true}
        modalClose={() => setShowParamModal(false)}
        onSubmitted={() => {
          setShowParamModal(false)
          if (paramKeysChange) {
            paramKeysChange()
          }
        }}
      /> */}
    </>
  )
}

export default ImportDataColorCar
